import {UserRoleInfo} from 'shared/models/UserRole';
import {Lang} from '../../../core/transloco/transloco-root.module';
import {UserRoles} from '../../../features/main-page/types';

export type UserInfoStore = {
  selectedUserRole?: UserRoleInfo;
  userRoles: UserRoleInfo[];
  userLanguage: Lang;
  userPermissions: UserRoles;
};
export const initialState: UserInfoStore = {
  selectedUserRole: undefined,
  userRoles: [],
  userLanguage: Lang.EN_GB,
  userPermissions: [],
};
